import React, { Fragment } from 'react'
import { Navigate, useLocation } from 'react-router'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import { history } from 'index'
import store from 'store'
import { getUMKFromLocal } from 'pUtils'
// import Loader from 'components/cleanui/layout/Loader'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'
import AdminLayout from './Admin'
import EmptyLayout from './Empty'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
  admin: AdminLayout,
  empty: EmptyLayout,
  provisioning: PublicLayout,
}

// let previousPath = ''
let previousPathname = ''

const publicList = ['/publicPage']

const mapStateToProps = ({ user }) => ({
  loading: user.loading,
  // provisioning: user.provisioning,
  authorized: user.authorized,
})

const Layout = ({ loading, authorized, children }) => {
  const location = useLocation()
  // NProgress & ScrollTop Management
  // const { pathname, search } = location;
  const { pathname } = location

  // const currentPath = pathname + search
  if (previousPathname !== pathname) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  setTimeout(() => {
    NProgress.done()
    // previousPath = currentPath;
    previousPathname = pathname
  }, 300)

  // Layout Rendering
  let needAuth = true
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (
      publicList.findIndex((publicItem) => {
        return pathname.indexOf(publicItem) === 0
      }) > -1
    ) {
      needAuth = false
      return 'public'
    }
    if (pathname.indexOf('/downloadFile') === 0) {
      return 'empty'
    }
    if (pathname.indexOf('/redirect') === 0) {
      needAuth = false
      return 'empty'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      needAuth = false
      return 'auth'
    }
    if (/^\/masterPW(?=\/|$)/i.test(pathname)) {
      needAuth = true
      return 'auth'
    }
    if (/^\/admin(?=\/|$)/i.test(pathname)) {
      needAuth = true
      return 'admin'
    }
    return 'main'
  }

  const layout = getLayout()
  const Container = Layouts[layout]
  const token = store.get('app.user.token')
  const isUserAuthorized = authorized || token != null
  const isUserLoading = loading
  const isPublic = layout === 'public'
  const isAuthLayout = layout === 'auth'

  const BootstrappedLayout = () => {
    if (isPublic !== true) {
      if (isUserLoading && needAuth) {
        return null
      }
      if (needAuth && !isUserAuthorized) {
        console.log(' auth - ', pathname, needAuth, isAuthLayout, isUserAuthorized)
        return <Navigate to="/auth/login" />
      }

      getUMKFromLocal()
        .then((value) => {
          if (value == null && isUserAuthorized) {
            if (pathname.startsWith('/migration')) {
              window.addEventListener('popstate', () => {
                history.push(`/migration`)
              })
            }
          }

          if (value && isUserAuthorized) {
            if (
              pathname.startsWith('/auth/login') ||
              pathname.startsWith('/migration') ||
              pathname.startsWith('/masterPW/changePW')
            ) {
              history.push('/')
            }
          }
        })
        .catch((error) => {
          console.error('Error fetching UMK:', error)
        })
    }

    return <Container>{children}</Container>
  }

  return (
    <Fragment>
      <Helmet titleTemplate="OfficeMail Migration | %s" title="OfficeMail Migration" />
      {BootstrappedLayout()}
    </Fragment>
  )
}

export default connect(mapStateToProps)(Layout)
